import React, { Component } from "react";
import ReactGA from "react-ga";
import BannerImg from "../../assets/images/banner/it-consulting.png";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ServiceMatrix from "../../assets/images/act_services_matrix_center.png";

class ITConsultingServices extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Enterprise IT Consulting Services, Legacy Modernization & AI Enablement | Avani Cimcon</title>
          <meta
            name="keywords"
            content="enterprise software engineering, legacy modernization, AI enablement, AI-first application development, application modernization, enterprise integration, managed engineering teams, software evolution, AI strategy, enterprise automation, IT consulting services, information technology consulting services, IT consulting and solutions, IT consulting company, software consulting services, software development and consulting IT services, offshore development services, Java development, Microsoft technologies, DotNetNuke, quality assurance, project management, design suite"
          />
          <meta
            name="description"
            content="Enterprise IT consulting services since 1992. Avani Cimcon helps enterprises modernize mission-critical systems, extend existing software, integrate legacy and modern platforms, and build AI-first applications."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/it-consulting-services" />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Enterprise IT Consulting Services & Modernization</h1>
            <h5>Solutions</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <p className="font-weight-bold text-primary">
                Enterprise IT consulting is how we connect strategy, architecture, and delivery.
                Avani Cimcon combines software engineering, modernization, and AI enablement to
                evolve existing systems without discarding the business value already inside them.
              </p>

              <h5 className="text-primary mt-4 mb-3">Current commercial offerings</h5>
              <ul>
                <li className="mb-2">Enterprise Software Engineering</li>
                <li className="mb-2">Legacy Modernization</li>
                <li className="mb-2">Enterprise AI Enablement</li>
                <li className="mb-2">AI-first Application Development</li>
                <li className="mb-2">Application Modernization</li>
                <li className="mb-2">Enterprise Integration</li>
                <li className="mb-2">Managed Engineering Teams</li>
                <li className="mb-2">Software Evolution</li>
                <li className="mb-2">AI Strategy</li>
                <li>Enterprise Automation</li>
              </ul>

              <p>
                Avani Cimcon Technologies is an IS/ISO 9001:2008 company with decades of experience
                in designing enterprise systems for international clients. Our IT consulting
                services connect delivery planning, application modernization, enterprise
                integration, and AI-assisted engineering so enterprises can improve systems
                incrementally and safely.
              </p>
              <p>
                Our onsite and offshore delivery capabilities create a framework for enterprise
                technology infrastructure, modernization, and AI-assisted engineering. At the core
                of our strategy is a long-term partnership model built on operational efficiency,
                measurable quality, and practical delivery. That allows clients to evolve existing
                systems while moving toward AI-first capabilities in a controlled way.
              </p>
              <p>
                Our quality assurance processes, customized for a distributed enterprise delivery
                model, provide consistent and measurable quality. Efficient planning, reporting,
                and documentation allow daily project monitoring. We have the experience, the
                requisite skills, and the documented processes needed to deliver modernization and
                engineering programs on time and within budget.
              </p>

              <h5 className="text-primary mt-4 mb-3">
                Engineering experience archive across the software development life cycle:
              </h5>

              <ul>
                <li className="mb-2">Requirements analysis and documentation services</li>
                <li className="mb-2">System design services</li>
                <li className="mb-2">Product and web design services</li>
                <li className="mb-2">Development and programming services</li>
                <li className="mb-2">DBA services</li>
                <li className="mb-2">QA planning and testing services</li>
                <li className="mb-2">
                  System administrator, implementation and maintenance services
                </li>
                <li>Porting services</li>
              </ul>

              <div className="mt-4">
                <img src={ServiceMatrix} alt="Enterprise software engineering service matrix" />
              </div>

              <div className="mt-4 p-4 bg-light border rounded">
                <h5 className="text-primary mb-3">Why this IT consulting layer matters now</h5>
                <p className="mb-3">
                  This page is the bridge between strategic modernization and the domain-specific
                  proof that lives elsewhere on the site.
                </p>
                <ul className="mb-0">
                  <li className="mb-2">
                    <Link to="/services/managed-services">See how Managed Services keeps systems stable</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/services/dedicated-engineering-teams">See Dedicated Engineering Teams for embedded delivery</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/services/legacy-modernization">See the Legacy Modernization framework</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/services/enterprise-ai-enablement">See Enterprise AI Enablement</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/travel-hospitality">Use travel expertise to modernize booking and operations systems</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/healthcare">Apply healthcare experience to patient and workflow modernization</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/insurance">Use insurance domain knowledge for claims and policy modernization</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/legal">Support legal platforms with safer modernization patterns</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/dxchange">Show how DXchange supports enterprise integration</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/biz-rule-engine">Show how BizRuleEngine supports automation and decisioning</Link>
                  </li>
                  <li>
                    <Link to="/cms">Use CMS heritage as productized engineering proof</Link>
                  </li>
                </ul>
              </div>

              <div className="mt-4 p-4 bg-light border rounded">
                <h5 className="text-primary mb-3">Enterprise AI opportunities</h5>
                <p className="mb-3">
                  When the business needs a clearer view of AI enablement across existing systems,
                  the Enterprise AI hub consolidates the operating model, delivery patterns and
                  domain-specific entry points.
                </p>
                <Link to="/services/enterprise-ai-enablement">Explore Enterprise AI Enablement</Link>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ITConsultingServices;
